import React, { useState, useEffect, useRef } from "react";
import "./AboutMe.css";

function AboutMe() {
	const [scroll, setScroll] = useState(0);
	const [headline, setImageOne] = useState(200);
	const [paragraph, setImagetwo] = useState(200);
	const headlineOne = useRef(null);
	const paragraphOne = useRef(null);

	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".aboutMeHeadline");
			const textEl = document.querySelector(".aboutMeParagraph");

			if (!el || !textEl || !paragraphOne.current || !headlineOne.current)
				return;

			const screenHeight = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;
			const isInView = elPos + 200 < screenHeight && elPos > 0;

			textEl.style.opacity = isInView ? "1" : "0";
			textEl.style.transform = isInView
				? "translateX(0%)"
				: "translateX(-200%)";

			el.style.opacity = isInView ? "1" : "0";
			el.style.transform = isInView ? "translateX(0%)" : "translateX(200%)";
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);
	return (
		<article className='aboutmearticle'>
			<h2 ref={headlineOne} className='aboutMeHeadline'>
				Erlebnis
			</h2>
			<p ref={paragraphOne} className='aboutMeParagraph'>
				Du möchtest die Erde von oben sehen wie ein Vogel ? Dann buche jetzt
				einen Rundflug....
			</p>
		</article>
	);
}

export default AboutMe;
